import { createStore } from 'jotai';

// Create a Jotai store instance that can be used outside of React components
export const jotaiStore = createStore();
